<template>
  <div class="homework-item" v-if="homeworkInfo" @click="jumpCompletedHomeworkList">
    <div class="homework-item-top">
      <div class="top-course-name" :style="{'background-color':$courseList[homeworkInfo.courseName]?$courseList[homeworkInfo.courseName].bgColor:$courseList['其他'].bgColor}">
        {{ homeworkInfo.courseName || homeworkInfo.course_name}}
      </div>
      <div class="top-progress">
        <div class="progress-reviewed">
          <span class="reviewed-label">批改:</span
          ><span class="reviewed-value" :class="homeworkInfo.checkTotal>0?homeworkInfo.checkTotal==homeworkInfo.classTotal?'complated':'incomplete':'not-started'">{{homeworkInfo.checkTotal}}/{{homeworkInfo.classTotal}}</span>
        </div>
        <div class="progress-completed">
          <span class="completed-label">完成:</span
          ><span class="completed-value" :class="homeworkInfo.finishTotal>0?homeworkInfo.finishTotal==homeworkInfo.classTotal?'complated':'incomplete':'not-started'">{{homeworkInfo.finishTotal}}/{{homeworkInfo.classTotal}}</span>
        </div>
      </div>
    </div>
    <div class="homework-item-center">
      <div class="center-homework-title">
        {{ homeworkInfo.title }}
      </div>
    </div>
    <div class="homework-item-bottom">
      <div class="bottom-date">
        <div class="assign-date">{{ homeworkInfo.publicTime }}布置</div>
        <div class="closing-date">{{ homeworkInfo.endTime }}截止</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    homeworkInfo: {
      type: Object,
      require: true,
    },
  },
  methods:{
    jumpCompletedHomeworkList(){
      this.$router.push({
        path:'/completed-homework-list',
        query:{
          homeworkId:this.homeworkInfo.id,
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
@import "./homeworkItem.scss";
</style>